module.exports = __webpack_public_path__ + "ad.svg?270441ab64f3f080febee3e64b9cbf09";